<ng-container *ngIf="order$ | async as data; else showSpinner">
  <div class="order-confirmation-wrapper">
    <div class="ref-num" *ngIf="!hideRefNumEnabled">
      {{ 'orderConfirmation.referenceNumber' | cxTranslate : { orderCode: this.orderId } }}
    </div>
    <div
      *ngIf="showConformationText"
      class="confirmation-text"
      [innerHtml]="'orderConfirmation.confirmationText' | cxTranslate : { email: data.user?.originalEmailId }"
    ></div>
    <div class="delivery-wrapper" *ngIf="data.deliveryAddress">
      <div class="order-title">
        {{ 'orderConfirmation.deliveryDetails.title' | cxTranslate }}
      </div>
      <div class="delivery-for">
        <label>{{ 'orderConfirmation.deliveryDetails.deliveryFor' | cxTranslate }}</label>
        <div *ngIf="data.deliveryAddress?.firstName && data.deliveryAddress?.lastName; else companyName">
          {{ data.deliveryAddress?.title }} {{ data.deliveryAddress?.firstName }} {{ data.deliveryAddress?.lastName }}
        </div>
        <ng-template #companyName>
          <div *ngIf="showCompanyName">
            {{ data?.deliveryAddress?.companyName }}
          </div>
        </ng-template>
        <div *ngIf="data.deliveryAddress?.phone; else cellPhone">
          {{ 'orderConfirmation.deliveryDetails.phoneNumber' | cxTranslate }} {{ data.deliveryAddress?.phone }}
        </div>
        <ng-template #cellPhone>
          <div *ngIf="data.deliveryAddress?.cellphone">
            {{ 'orderConfirmation.deliveryDetails.phoneNumber' | cxTranslate }} {{ data.deliveryAddress?.cellphone }}
          </div>
        </ng-template>
      </div>
      <div class="delivery-addr">
        <label>{{ 'orderConfirmation.deliveryDetails.deliveryAddr' | cxTranslate }}</label>
        <div [innerHTML]="showAddress(data.deliveryAddress) | async"></div>
      </div>
    </div>
    <div class="payment-wrapper" *ngIf="data.paymentInfoDetails">
      <div class="order-title">
        {{ 'orderConfirmation.paymentDetails.title' | cxTranslate }}
      </div>
      <div class="payment-details-wrapper">
        <div class="payment-method">
          <label>{{ 'orderConfirmation.paymentDetails.method' | cxTranslate }}</label>
          <div>
            {{ data.paymentInfoDetails?.paymentModeName }}
          </div>
        </div>
        <div class="payment-terms">
          <label>{{ 'orderConfirmation.paymentDetails.terms' | cxTranslate }}</label>
          <div>
            {{ data.paymentInfoDetails?.paymentTerms }}
          </div>
        </div>
        <div class="payment-addr">
          <label>{{ 'orderConfirmation.paymentDetails.billingAddr' | cxTranslate }}</label>
          <div [innerHTML]="showAddress(data.paymentInfoDetails?.billingAddress) | async"></div>
          <div *ngIf="data.paymentInfoDetails?.billingAddress?.phone; else billingCellPhone">
            {{ 'orderConfirmation.deliveryDetails.phoneNumber' | cxTranslate }}
            {{ data.paymentInfoDetails?.billingAddress?.phone }}
          </div>
          <ng-template #billingCellPhone>
            <div *ngIf="data.paymentInfoDetails?.billingAddress?.cellphone">
              {{ 'orderConfirmation.deliveryDetails.phoneNumber' | cxTranslate }}
              {{ data.paymentInfoDetails?.billingAddress?.cellphone }}
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #showSpinner>
  <div class="results-spinner">
    <mat-spinner [diameter]="72"></mat-spinner>
  </div>
</ng-template>
